import React from 'react'
import {
  IAuditEventData,
  LicensedAgencyConfigurationAuditSnapshotV1,
} from '../../../api'
import { useDetailStyles } from './useDetailStyles'
import { Box } from 'cs-kevlar-react'
import { UnavailableDetails } from './UnavailableDetails'
import { resolveSnapshots } from './utils'
import { DetailField } from './DetailField'
import { DetailArrayField } from './DetailArrayField'
import { DetailSectionHeading } from './DetailSectionHeading'

interface CustomerLicensedAgencyConfigurationDetailsProps {
  eventData: IAuditEventData
}

export const CustomerLicensedAgencyConfigurationDetails: React.FunctionComponent<CustomerLicensedAgencyConfigurationDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    LicensedAgencyConfigurationAuditSnapshotV1
  >(eventData, nameof<LicensedAgencyConfigurationAuditSnapshotV1>())
  const showDiff = !!originalSnapshot && !!updatedSnapshot

  if (!updatedSnapshot && !originalSnapshot) return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailSectionHeading title="Devices" />

        <DetailField
          label="Session Lock Timeout (minutes)"
          showDiff={showDiff}
          original={originalSnapshot?.deviceSessionLockTimeoutInMinutes?.toString()}
          updated={updatedSnapshot?.deviceSessionLockTimeoutInMinutes?.toString()}
        />
      </Box>

      <Box className={classes.fieldsContainer}>
        <DetailSectionHeading title="App Notifications" />

        <DetailField
          label="Several Units Assigned to a Call"
          showDiff={showDiff}
          original={originalSnapshot?.incidentNotificationSignificantUnitsAssigned?.toString()}
          updated={updatedSnapshot?.incidentNotificationSignificantUnitsAssigned?.toString()}
        />

        <DetailArrayField
          label="High Priorities"
          showDiff={showDiff}
          original={Object.values(
            originalSnapshot?.incidentNotificationHighPriorities ?? [],
          )}
          updated={Object.values(
            updatedSnapshot?.incidentNotificationHighPriorities ?? [],
          )}
        />

        <DetailArrayField
          label="Statuses"
          showDiff={showDiff}
          original={Object.values(
            originalSnapshot?.incidentNotificationStatuses ?? [],
          )}
          updated={Object.values(
            updatedSnapshot?.incidentNotificationStatuses ?? [],
          )}
        />
      </Box>
    </React.Fragment>
  )
}
